var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "thead",
    [
      _c(
        "tr",
        [
          _vm.lineNumbers
            ? _c("th", { staticClass: "line-numbers" })
            : _vm._e(),
          _vm._v(" "),
          _vm.selectable
            ? _c("th", { staticClass: "vgt-checkbox-col" }, [
                _c(
                  "label",
                  {
                    staticClass:
                      "vgt-checkbox-label kt-checkbox kt-checkbox--single kt-checkbox--solid"
                  },
                  [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: _vm.allSelected,
                        indeterminate: _vm.allSelectedIndeterminate
                      },
                      on: { change: _vm.toggleSelectAll }
                    }),
                    _vm._v(" "),
                    _c("span")
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.columns, function(column, index) {
            return !column.hidden
              ? _c(
                  "th",
                  {
                    key: index,
                    class: _vm.getHeaderClasses(column, index),
                    style: _vm.columnStyles[index],
                    on: {
                      click: function($event) {
                        return _vm.sort($event, column)
                      }
                    }
                  },
                  [
                    _vm._t(
                      "table-column",
                      [_c("span", [_vm._v(_vm._s(column.label))])],
                      { column: column }
                    )
                  ],
                  2
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("vgt-filter-row", {
        ref: "filter-row",
        tag: "tr",
        attrs: {
          "global-search-enabled": _vm.searchEnabled,
          "line-numbers": _vm.lineNumbers,
          selectable: _vm.selectable,
          columns: _vm.columns,
          mode: _vm.mode,
          "typed-columns": _vm.typedColumns
        },
        on: { "filter-changed": _vm.filterRows }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }